module.exports = __webpack_public_path__ + "static/media/donate-blue-kn.1e88b7b1.svg";